exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar[data-v-e9a1b2d4]{display:flex;justify-content:space-between;height:40px;background-color:#fff;padding:1rem 20px}.telephone[data-v-e9a1b2d4]{color:#082f2a}.logo[data-v-e9a1b2d4]{height:100%}.btn-language[data-v-e9a1b2d4]{height:30px;width:30px;border-radius:50%;border:2px solid #082f2a;display:flex;justify-content:center;align-items:center;font-family:Styrene A Web;color:#082f2a;cursor:pointer;font-weight:700;transition:.5s ease-in-out}.btn-language[data-v-e9a1b2d4]:hover{background-color:#082f2a;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e9a1b2d4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavBar.vue
// module id = 87
// module chunks = 8